import type { PimWorkflowDetail } from "@nova-ai/shared"
import { Button } from "../ui/button"
import {
  WORKFLOW_STAGES,
  workflowReason,
} from "../pim-workflow-history/workflow-history-presentation"

type Blocker = PimWorkflowDetail["blockers"]["scopes"][number]
export function NutritionBlockers({
  blockers,
  onSelect,
  onShowFailed,
}: {
  blockers: PimWorkflowDetail["blockers"]
  onSelect: (scope: Blocker) => void
  onShowFailed: () => void
}) {
  if (!blockers.scopeCount && !blockers.deliveryFailures) {
    return null
  }
  return (
    <section aria-label="Unresolved failures" className="space-y-3">
      <h3 className="text-[13px] font-semibold">Unresolved failures</h3>

      {blockers.deliveryFailures > 0 && (
        <p className="text-sm text-destructive">{`${blockers.deliveryFailures} delivery failures remain unresolved. Delivery processing failed; no more specific safe cause is recorded here.`}</p>
      )}

      {blockers.scopeCount > 0 && (
        <>
          <p className="text-sm">{`${blockers.scopeCount} failed ${blockers.scopeCount === 1 ? "scope" : "scopes"} across this receipt`}</p>

          <ul className="divide-y divide-border">
            {blockers.scopes.map((scope) => (
              <li key={scope.id} className="py-2">
                <button
                  type="button"
                  className="min-h-11 w-full rounded-lg py-2 text-left text-sm text-info underline focus-visible:ring-2 focus-visible:ring-ring"
                  onClick={() => onSelect(scope)}
                >
                  <span className="block break-words">{`${scope.store} · ${scope.sku ?? "SKU unresolved"}`}</span>

                  <span className="text-xs">{`Open failed scope · target #${scope.targetId}`}</span>
                </button>

                {scope.failures.map((failure) => (
                  <p
                    key={failure.stage}
                    className="text-xs text-foreground"
                  >{`${WORKFLOW_STAGES.find(([key]) => key === failure.stage)?.[1]}: ${workflowReason(failure.reason)}`}</p>
                ))}
              </li>
            ))}
          </ul>

          <Button className="min-h-11" onClick={onShowFailed}>
            Browse all failed scopes
          </Button>

          <p className="text-xs text-muted-foreground">
            Recovery eligibility requires the exact target preview below. A failure alone does not
            authorize recovery.
          </p>
        </>
      )}
    </section>
  )
}
